import Token from '@/utils/Token';

export default {
    parse(data) {
        ['ativo'].forEach(item => {
            data[item] = parseInt(data[item]);
        });

        return data;
    },

    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/solicitante/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/solicitante/list${params}`, Token.getHeader());
    },
    option(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/solicitante/option${params}`, Token.getHeader());
    },

    create(params) {
        return axios.post(`/api/solicitante`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/solicitante/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/solicitante/${id}`, Token.getHeader());
    },
}
